import React, { useMemo } from "react";
import { Alert as AlertAntd, Col, Row, Typography } from "antd";
import { DetectionStatusData } from "../../types";
import { ReactComponent as MosquitoIconSvg } from "../../assets/icons/MosquitoVector.svg";

const { Text } = Typography;

type Props = {
  item: DetectionStatusData;
  onClick?: (id: string) => void;
};

const AlertDialog: React.FC<Props> = ({ item, onClick }) => {
  const dateString = useMemo(() => {
    const createdAt = item.created_at;
    if (!createdAt) return "";

    const d =
      createdAt instanceof Date
        ? createdAt
        : new Date(
            createdAt +
              (createdAt.endsWith("+00:00") ||
              createdAt.toLowerCase().endsWith("z")
                ? ""
                : "+00:00"),
          );

    const dateString = d
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(" at", ",");

    // const [datePart, hourPart] = dateString.split(",");

    // return { date: datePart, hour: hourPart };
    return dateString;
  }, [item.created_at]);

  const message = (item?.message || "").replace(/^\[.+\]/, "");

  return (
    <div
      key={item?._id}
      className="alert-dialog-container alert-dialog-container--primary"
    >
      <AlertAntd
        onClick={() => onClick && onClick(item?._id)}
        message={
          <Row
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Col style={{ flex: 1, minWidth: 0 }}>
              <Row>
                <Text className="font-bold">{message}</Text>
              </Row>
              <Row>
                <Text>
                  <span className="alert-description">
                    {item?.trapsite_name || "Unknown Location"} -{" "}
                    {item?.device_name}
                  </span>
                </Text>
              </Row>
            </Col>
            <Col style={{ flexShrink: 0 }}>
              <Row>
                <Text className="text-[14px]!">{dateString} </Text>
              </Row>
            </Col>
          </Row>
        }
        type="warning"
        showIcon
        icon={<MosquitoIconSvg width={24} height={24} fill="#F4C000" />}
      />
    </div>
  );
};

export default AlertDialog;
